/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../../../common/utilities';
import InputList from '../../../../components/general/input-list';

const InputWrapper = styled.div`
	background: #fff;
	border-radius: 5px;

	& a {
		display: block;
		text-decoration: none;
		color: #43aaf1;
		padding: 8px 18px 9px 11px;
	}

	& li.selected,
	& a {
		font-size: 16px;
	}
`;

const ListWrapper = styled.div`
	position: absolute;
	z-index: 10;
	background: #fff;
	padding: 0 11px 0 27px;
	border-radius: 5px;
	width: 128%;

	& li {
		font-size: 14px;
		padding: 7px 0;
		border-color: #D5D6D7;
	}
`;

class Step extends React.Component {
    constructor() {
        super();

        this.state = {
            expanded: null,
            current: 'Arbeitsschritt wählen',
        }
    }

    toggle() {
        const {expanded} = this.state;

        this.setState({expanded: !expanded})
    }

    handleSelect = (val) => {
        this.toggle();
        this.setState({current: val});
        this.props.handleChange(val);
    };

    render() {
        const {steps, currentTask, isreport} = this.props;
        const {expanded, current} = this.state;

        const items = convertToItems(steps, current);

        return (
            <InputWrapper>
                {expanded
                    ? (
                        <ListWrapper>
                            <InputList items={items} handleClick={this.handleSelect} currentTask={currentTask} isreport={isreport}/>
                        </ListWrapper>
                    )
                    : <a href="#" onClick={(e) => {
                        e.preventDefault();
                        this.toggle();
                    }}>{current.label} - {current.name}</a>
                }
            </InputWrapper>
        );
    }
}

export default Step;



// WEBPACK FOOTER //
// ./src/components/task/working/report/step.js